import React, { useState } from "react";
import "./index.css";
import { Language } from "../../types";
import { useContextProvider } from "../../context";
import { makes } from "../../data/cars";

const dict = {
  [Language.English]: {
    title: "Show",
    all: "All cars",
    cabriolets: "Cabriolets",
    carsLength: "Cars in list",
    clearFilters: "Clear filters",
  },
  [Language.Spanish]: {
    title: "Mostrar",
    all: "Todos los coches",
    cabriolets: "Convertibles",
    carsLength: "Coches en la lista",
    clearFilters: "Limpiar filtros",
  },
  [Language.Russian]: {
    title: "Показать",
    all: "Все автомобили",
    cabriolets: "Кабриолеты",
    carsLength: "Автомобилей в списке",
    clearFilters: "Удалить фильтры",
  },
  [Language.Ukrainian]: {
    title: "Показати",
    all: "Всі автомобілі",
    cabriolets: "Кабріолети",
    carsLength: "Автомобілів у списку",
    clearFilters: "Видалити фільтри",
  },
};

interface FilterProps {
  filters: { [key: string]: boolean };
  setFilters: (filters: { [key: string]: boolean }) => void;
  carsLength: number;
}

export const Filter: React.FC<FilterProps> = ({
  filters,
  setFilters,
  carsLength,
}) => {
  const { language } = useContextProvider();

  const nothingSelected = Object.values(filters).every((value) => !value);

  const showAllHandler = () => {
    setFilters({});
  };

  const showCabrioletsHandler = () => {
    showMakeHandler("cabrio");
  };

  const showMakeHandler = (make: string) => {
    const isMakeSelected = !!filters[make];
    setFilters({ ...filters, [make]: !isMakeSelected });
  };

  const clearFiltersHandler = () => {
    setFilters({});
  };

  return (
    <section className="Filter">
      <div className="Filter-container">
        <h2>{dict[language].title}:</h2>
        <div className="Filter-buttons">
          <button
            className={nothingSelected ? "selected" : ""}
            onClick={showAllHandler}
          >
            {dict[language].all}
          </button>
          <button
            className={filters["cabrio"] ? "selected" : ""}
            onClick={showCabrioletsHandler}
          >
            {dict[language].cabriolets}
          </button>
          {makes.map((make) => (
            <button
              className={filters[make] ? "selected" : ""}
              key={make}
              onClick={() => showMakeHandler(make)}
            >
              <img
                src={`/images/logos/${make.toLowerCase().replace(" ", "")}.webp`}
                alt={make}
                width={20}
                height={20}
              />
              {make}
            </button>
          ))}
        </div>
        <div>
          {dict[language].carsLength}: {carsLength}{" "}
          <button className="Filter-clear" onClick={clearFiltersHandler}>
            {dict[language].clearFilters}
          </button>
        </div>
      </div>
    </section>
  );
};
